import { useTranslation } from "react-i18next";

import { Table } from "@pentabd/ui";

import { TableColumn } from "./TableColumn";
import { TableFilter } from "./TableFilter";

import { useManpowerRecruitReports } from "@hooks/HRM/reports/useManpowerRecruitReports";

export const ManpowerRecruitTable = () => {
  const { t } = useTranslation();
  const { handleQuery, getManpowerRecruitData } = useManpowerRecruitReports();

  return (
    <div className="pt-10">
      <TableFilter handleQuery={handleQuery} />
      <Table
        columns={TableColumn(t) || []}
        rows={getManpowerRecruitData || []}
        isStickyHeader
        height={getManpowerRecruitData?.length > 6 ? 500 : undefined}
      />
    </div>
  );
};
